(function () {
  var nodes = document.querySelectorAll('[data-urb-countup]');
  if (!nodes.length) return;

  function format(value) {
    var n = Math.round(value);
    return n >= 10000 ? n.toLocaleString(document.documentElement.lang || 'pl') : String(n);
  }

  function animate(el) {
    var target = parseFloat(el.getAttribute('data-target')) || 0;
    var duration = 1400;
    var begin = null;
    function ease(t) { return 1 - Math.pow(1 - t, 3); }
    function frame(now) {
      if (begin === null) begin = now;
      var progress = Math.min((now - begin) / duration, 1);
      el.textContent = format(target * ease(progress));
      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        el.textContent = format(target);
      }
    }
    requestAnimationFrame(frame);
  }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduce || !('IntersectionObserver' in window)) {
    nodes.forEach(function (el) {
      el.textContent = format(parseFloat(el.getAttribute('data-target')) || 0);
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animate(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.4 });

  nodes.forEach(function (el) { observer.observe(el); });
})();